import { useState } from 'react';
import { SmartFormIcons, SmartFormIconVariants } from 'components';
import { Popover } from 'components-antd';
import { FormFieldComment } from 'pages/FormProcess/components';

import styles from './styles.module.scss';

import { useManageFormComments } from '../hooks/useManageFormComments';

export const CommentPopover = (props) => {
  const [fieldInfo, setFieldInfo] = useState<any>(undefined);
  const { field, isHighlighted, itemRef } = props;

  const selectedField = isHighlighted ? field : undefined;

  const {
    commentActions: { handleAddFormComment },
  } = useManageFormComments();

  return (
    <div className={styles.commentPopoverContainer} ref={itemRef}>
      <Popover
        key={'pdf-Thread'}
        destroyTooltipOnHide
        placement="bottom"
        overlayClassName={styles.popoverContent}
        zIndex={9999}
        content={
          <FormFieldComment
            fieldInfo={fieldInfo}
            handleAddFormComment={handleAddFormComment}
            dynamicComment
          />
        }
        trigger={'click'}
        open={isHighlighted ? fieldInfo?.id === selectedField?.id : false}
        onOpenChange={(visible) => !visible && fieldInfo && setFieldInfo(undefined)}
        getTooltipContainer={() => itemRef.current}
      >
        <div
          className={styles.helpOption}
          onClick={(e) => {
            e.stopPropagation();
            setFieldInfo(selectedField);
          }}
        >
          <SmartFormIcons variant={SmartFormIconVariants.CommentWhite} /> Comment
        </div>
      </Popover>
    </div>
  );
};
